export const DOCS_IMPORT_STEPS = {
  UPLOAD_FILES: "upload_files",
  UPLOAD_CSV: "upload_csv",
  MAPPING: "mapping",
  VALIDATION: "validation",
  VALUE_MAPPING: "value_mapping",
  ANALYSIS: "analysis",
  LINKING: "linking",
  RESULT: "result",
};

export const DOCUMENT_TYPE_KEYS = [
  "STATUSES",
  "IPID",
  "INFO_NOTICE",
  "BROCHURE",
  "RGPD",
  "REIMBURSEMENT_EXAMPLES",
  "PARTICULAR_PROVISIONS",
  "REGULATION",
];

export const DOCS_FIELD_KEYS = [
  "identifier",
  "documentName",
  "devis",
  "contrat",
  "signature",
];

export const BOOLEAN_FIELD_KEYS = new Set(["devis", "contrat", "signature"]);

const TRUTHY_SAMPLE_VALUES = new Set([
  "true",
  "1",
  "oui",
  "yes",
  "vrai",
  "v",
  "y",
  "o",
  "x",
]);

const FALSY_SAMPLE_VALUES = new Set([
  "false",
  "0",
  "non",
  "no",
  "faux",
  "f",
  "n",
  "",
]);

const parseSampleBoolean = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === "boolean") return value;
  if (typeof value === "number") {
    if (value === 1) return true;
    if (value === 0) return false;
    return null;
  }

  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return null;
  if (TRUTHY_SAMPLE_VALUES.has(normalized)) return true;
  if (FALSY_SAMPLE_VALUES.has(normalized)) return false;

  // Excel often formats boolean TRUE/FALSE as 01/01/1900 dates
  if (
    /^(0?1)[/\-.](0?1)[/\-.](1900|00)(?:\b|$)/.test(normalized) ||
    /^1900-01-01/.test(normalized)
  ) {
    return true;
  }
  if (
    /^(0?0)[/\-.](0?1)[/\-.](1900|00)(?:\b|$)/.test(normalized) ||
    /^1899-12-3[01]/.test(normalized)
  ) {
    return false;
  }

  return null;
};

/** Formats boolean preview samples as VRAI / FAUX for mapping UI. */
export const formatDocsSampleValue = (val, fieldKey) => {
  if (!BOOLEAN_FIELD_KEYS.has(fieldKey)) return val;
  const parsed = parseSampleBoolean(val);
  if (parsed === true) return "VRAI";
  if (parsed === false) return "FAUX";
  return val;
};

export const ACCEPTED_FILE_EXTENSIONS = [".xls", ".xlsx", ".csv"];
export const FILE_ACCEPT_STRING = ".xls,.xlsx,.csv";
export const PDF_ACCEPT_STRING = ".pdf";

export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const MAX_PDF_SIZE_MB = 10;
export const MAX_PDF_SIZE_BYTES = MAX_PDF_SIZE_MB * 1024 * 1024;

export const CSV_TEMPLATE_HEADERS = [
  "Identifiant *",
  "Nom du document *",
  "Devis",
  "Contrat",
  "Signature",
];

export const CSV_TEMPLATE_EXAMPLE_ROW = [
  "plan-sante-1",
  "IPID.pdf",
  "VRAI",
  "VRAI",
  "FAUX",
];

export const resolveError = (err, errorKeys) => {
  if (typeof err === "string") return err;
  if (!err || !err.key) return String(err);
  const template = errorKeys && errorKeys[err.key] ? errorKeys[err.key] : null;
  if (!template) return err.key;
  const resolved = Object.entries(err.params || {}).reduce(
    (msg, [k, v]) => msg.replaceAll(`{{${k}}}`, v || ""),
    template,
  );
  return resolved.replace(/\s*\{\{[^}]+\}\}/g, "").trim();
};
